import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'minLength',
    standalone: true
})
//ensures that the input is of the minimum length and prepends with pad if it's shorter than len.
export class MinLengthPipe implements PipeTransform {
    transform(inputSource: any, len: number, pad: string = null):string {
        const input = (inputSource || 0).toString();

        if (input.length >= len) return input;
        else {
            pad = (pad || 0).toString();
            return new Array(1 + len - input.length).join(pad) + input;
        }
    }
}